import React, { Component } from "react"
import {
  BarChart,
  Bar,
  ResponsiveContainer,
  YAxis,
  XAxis,
  LabelList
} from "recharts"

import { Metric, FUNNEL_GRADIENTS, selectFormat } from "./../Utils/Utils.js"
import Heading from "../Elements/Heading"

class NewSubsByPlatform extends Component {

  labelFormatter = (value) => (
    selectFormat("number", value)
  )

  renderFunnel = (data, index) => {
    let COLORS = FUNNEL_GRADIENTS[index]

    return (
      <div key={index} className="col-12 col-sm-6 col-md-6 col-lg-4 mt-4">
        <div className="text-center">
          <Heading size={6}className={"mb-0 text-gray"}>
            {data.name}
          </Heading>
        </div>

        <ResponsiveContainer height={200}>
          <BarChart
            data={data.chart}
            barCategoryGap={0}

            layout="vertical"
            margin={{ top: 10, right: 10, left: 0, bottom: 0 }}
          >
            <XAxis type="number" dataKey="value" hide={true} scale="log" domain={[0.01, 'auto']} allowDataOverflow />
            <YAxis
              type="category"
              dataKey="type"
              axisLine={false}
              tickLine={false}
              interval={0}
              fontSize={11} fontWeight={700} fontFamily={'Museo Slab W01'}
              width={140}
            />

            <defs>
              <linearGradient
                id={`gradient${index}`}
                x1="1"
                y1="0"
                x2="0"
                y2="0"
              >
                <stop offset="5%" stopColor={COLORS[0]} stopOpacity={1} />
                <stop offset="95%" stopColor={COLORS[1]} stopOpacity={1} />
              </linearGradient>
            </defs>

            <Bar key={index} dataKey="value" fill={`url(#gradient${index})`} maxBarSize={60}>
              <LabelList dataKey="value" position="insideLeft" offset={10} fontSize={11} fontWeight={700} fontFamily={'Museo Slab W01'} formatter={this.labelFormatter} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>

        <div className="row mt-4 mb-4">
          <div className="col-12 d-flex flex-column align-items-center mb-2">
            <Heading size={6}className={"mb-0 text-gray"}>
              CPC
            </Heading>
            <Metric {...data.cpc} size={"sm"} format={"$0.00a"} />
          </div>
          <div className="col-12 d-flex flex-column align-items-center">
            <Heading size={6}className={"mb-0 text-gray"}>
              CPA
            </Heading>
            <Metric {...data.cpa} size={"sm"} type={"currency"} />
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { data } = this.props
    return (
      <div className="row">
        {data.data.map((item, index) => this.renderFunnel(item, index))}
      </div>
    )
  }
}

export default NewSubsByPlatform
